"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFileManagerPortalData = fetchFileManagerPortalData;
exports.updateVidyardTosStatus = updateVidyardTosStatus;
exports.updateVideoPQLDismissFlag = updateVideoPQLDismissFlag;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FileManagerPortalDataCategories = _interopRequireDefault(require("../enums/FileManagerPortalDataCategories"));

var BASE_URL = 'filemanager/api/v3/portal-meta';

function fetchFileManagerPortalData(earlyRequesterPromise) {
  var promise = earlyRequesterPromise || _apiClient.default.get(BASE_URL);

  return promise.then(function (response) {
    return _immutable.default.fromJS(response);
  });
}

function overwriteVidyardTosStatus(data) {
  return _apiClient.default.post(BASE_URL + "/upsert", {
    data: data
  }).then(function (response) {
    return _immutable.default.fromJS(response);
  });
}

function updateVidyardTosStatus(status) {
  var networkPayload = {
    category: _FileManagerPortalDataCategories.default.VIDYARD_TOS_STATUS,
    category_value: status
  };
  return overwriteVidyardTosStatus(networkPayload);
}

function updateVideoPQLDismissFlag(hasDismissedVideoPQL) {
  return _apiClient.default.post(BASE_URL + "/upsert", {
    data: {
      category: _FileManagerPortalDataCategories.default.DISMISS_VIDEO_PQL_V1,
      category_value: hasDismissedVideoPQL
    }
  });
}